<template>
    <div>
        <el-dialog top="5%" title="新增" v-model="editFormVisible" :visible.sync="editFormVisible" :close-on-click-modal="false">
            <el-form ref="form" :model="form" :rules="rules" label-width="110px">
                <el-form-item label="阶段" prop="FName">
                    <el-input v-model="form.FName"></el-input>
                </el-form-item>
                   <el-form-item label="是否目录" prop="FIsTask">
                    <el-radio-group v-model="form.FIsTask" @change="changeIsTask">
                        <el-radio :label="0" >目录</el-radio>
                        <el-radio :label="1" >节点</el-radio> 
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="排序" prop="FSort"  >
                    <el-input type="number" v-model="form.FSort"></el-input>
                </el-form-item>
                  <el-form-item label="负责人" prop="FLeader"> 
                    <sy-select v-model="form.FLeader"
                               optionData="server/system/User.ashx?cmd=GetUserOptions">
                    </sy-select>
                </el-form-item>
                 <el-form-item label="开始时间" prop="FStartTime" >
                    <el-date-picker type="datetime" placeholder="选择时间" v-model="form.FStartTime" style="width: 100%;"></el-date-picker>
                </el-form-item>
                 <el-form-item label="结束时间" prop="FEndTime" >
                    <el-date-picker type="datetime" placeholder="选择日期" v-model="form.FEndTime" style="width: 100%;"></el-date-picker>
                </el-form-item>
                 <el-form-item label="标准用时(秒)" prop="FSTDTime" v-if="istask">
                    <el-input style="width:20%;" type="number" v-model="hours" min="0"></el-input>时
                    <el-input style="width:20%;"  type="number" v-model="minutes" min="0"></el-input>分
                    <el-input style="width:20%;"  type="number" v-model="seconds" min="0"></el-input>秒
                 </el-form-item>
                   <el-form-item label="要求说明" prop="FRemark" v-if="istask">
                   <VueUEditor @ready="editorReady" style="width:98%;height:450px;"></VueUEditor>
                </el-form-item>
                 <el-form-item label="图片" prop="FPic" v-if="istask">
                <sy-card-upload v-model="form.FPic"></sy-card-upload>
              </el-form-item>
                <el-form-item label="视频" prop="FVideo" v-if="istask">
                <sy-doc-upload v-model="form.FVideo"></sy-doc-upload>
              </el-form-item>
                 <el-form-item label="进度" prop="FProgress"  v-if="istask">
                    <el-input type="number" v-model="form.FProgress"></el-input>
                </el-form-item>
                 <el-form-item label="审核人" prop="FAuditUserId" v-if="form.FID>0">
                        <sy-select v-model="form.FAuditUserId"
                                   optionData="server/system/Staff.ashx?cmd=GetStafOptions&FDeptId=0">
                        </sy-select>
                  </el-form-item>
                <el-form-item label="备注" prop="FNote" >
                    <el-input type="textarea" v-model="form.FNote"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="editFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="save" :loading="loading">保存</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import util from '../../common/util'
    import mixin from '../../common/mixin'
       import VueUEditor from '../../components/UEditor';
    export default {
          components: { VueUEditor },
        mixins: [mixin],
        data() {
            return {
                form: {},
                rules: {
                    FName: [{required: true,message: '请填写阶段', trigger: 'blur'}],
                    FLeader: [{required: true,message: '负责人', trigger: 'blur'}],
                    FStartTime: [{required: true,message: '开始时间', trigger: 'blur'}],
                    FEndTime: [{required: true,message: '结束时间', trigger: 'blur'}]
                },
                loading:false,
                editFormVisible:false,
                istask:true,
                hours:0,
                minutes:0,
                seconds:0
            }
        },
        methods: {
            _openEdit(record) {
                this.editFormVisible = true;
                this.form = Object.assign({},record);
                this.hours = Math.trunc(record.FSTDTime/3600)
                this.minutes = Math.trunc((record.FSTDTime-(3600*this.hours))/60)   
                this.seconds =  (record.FSTDTime-(3600*this.hours)-(60*this.minutes))
                this.istask = record.FIsTask
            },
            _openAdd(record) {
                this.editFormVisible = true;
                this.form = {FID:0,FSort:0,FProjectId:0,FLeader:0,FProgress:0,FIsTask:1,Note:'',FRemark:'',FPic:'',FNote:'',FVideo:'',FAuditUserId:0};
                this.form.FProjectId= record.FJobID;
                this.form.FParentId = record.PID?record.PID:0
            },
            save:function () {
                  this.form.FRemark = this.form.Note
                if(this.hours==''||this.hours<0) this.hours=0
                if(this.minutes==''||this.minutes<0) this.minutes=0
                if(this.seconds==''||this.seconds<0) this.seconds=0
                this.form.FSTDTime = parseInt(this.hours*3600)+parseInt(this.minutes*60)+parseInt(this.seconds)
                let url = "server/business/Project.ashx?cmd=SaveDetail"
                util.saveForm(url,this.$refs.form,this.form,this.loadFn("loading"),result=> {
                    this.editFormVisible = false
                    this.$emit("onSaveSuc",this.form)
                })
            },
             changeIsTask(val){
                console.log(val)
                if(val==1){
                    this.istask=1
                }
                else{
                    this.istask=0
                }
            },
              editorReady (editorInstance) {
                
                editorInstance.setContent(this.form.FRemark);
                editorInstance.addListener('contentChange', () => {
                    console.log(1111)
                     console.log(editorInstance.getContent())
                    this.form.Note=editorInstance.getContent();

                });
            }
        },
        mounted() {

        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/business/ProjectDetail_Edit.vue